import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import WhitelabelConfigCustomOptionsForm from './WhitelabelConfigCustomOptionsForm';
import WhitelabelConfigCustomOptionsService from '../services/WhitelabelConfigCustomOptionsService';

class WhitelabelConfigCustomOptionsFormContainer extends Component {
  static propTypes = {
    whitelabelConfigId: PropTypes.string,
  };

  static defaultProps = {
    whitelabelConfigId: null,
  };

  whitelabelConfigFormService = new WhitelabelConfigCustomOptionsService();
  componentWillMount() {
    this.whitelabelConfigFormService.init(this.props.whitelabelConfigId);
  }

  render() {
    return (
      <WhitelabelConfigCustomOptionsForm
        onSubmit={this.whitelabelConfigFormService.handleSubmit}
        onChange={this.whitelabelConfigFormService.form.setValue}
        onReset={this.whitelabelConfigFormService.form.reset}
        values={this.whitelabelConfigFormService.form.getValues()}
        errors={this.whitelabelConfigFormService.form.errors}
        submitting={this.whitelabelConfigFormService.submit.fetching}
        isDirty={this.whitelabelConfigFormService.form.isDirty}
      />
    );
  }
}

export default observer(WhitelabelConfigCustomOptionsFormContainer);
